import { render, staticRenderFns } from "./TemplateUebersicht.vue?vue&type=template&id=37d9a36a&scoped=true&"
import script from "./TemplateUebersicht.vue?vue&type=script&lang=js&"
export * from "./TemplateUebersicht.vue?vue&type=script&lang=js&"
import style0 from "./TemplateUebersicht.vue?vue&type=style&index=0&id=37d9a36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9a36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
